export default "__VITE_ASSET__zfbL2hov__ 1600w, __VITE_ASSET__agekUbB___ 800w";